// import { doIt } from "@/utils/doIt";

//

// export type TSentry = typeof Sentry;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TSentry = any;

//

class SentryService {
  private sentry: TSentry | null = null;

  //

  // constructor() {
  // doIt(async () => {
  //   if (process.env.TYPE === "BACKEND") {
  //     const Sentry = await import("@sentry/node");
  //     //
  //     Sentry.init({
  //       dsn: "https://99c9083383f272a3f1f6fd8bd0927080@o4506909492445184.ingest.us.sentry.io/4506909495721984",
  //       // Performance Monitoring
  //       tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //       // Set sampling rate for profiling - this is relative to tracesSampleRate
  //       profilesSampleRate: 1.0,
  //     });
  //     this.sentry = Sentry;
  //   }
  // });
  // }

  //

  public captureCheckIn(...p: Parameters<TSentry["captureCheckIn"]>): string | undefined {
    return this.sentry?.captureCheckIn(...p);
  }

  //

  public captureException(...p: Parameters<TSentry["captureException"]>): string | undefined {
    return this.sentry?.captureException(...p);
  }

  //

  public captureMessage(...p: Parameters<TSentry["captureMessage"]>): string | undefined {
    return this.sentry?.captureMessage(...p);
  }
}

//

export default new SentryService();
